import { useLocation, matchPath } from 'react-router-dom';
import { useEffect, useState, useCallback } from 'react';

const checkMatchingRoutes = (routes: string, hash: string) =>
  !hash || routes.split('|').some(route => matchPath(route, hash.split(/[?#]/)[1]));

const IFRAME_MODAL_MESSAGE_EVENT_NAME = {
  OPEN: 'ang.app.modal.open',
  CLOSE: 'ang.app.modal.close',
};

const useVisibiityForLegacyUrl = (routes: string) => {
  const { hash, pathname } = useLocation();
  const [isVisible, updateVisibility] = useState(true);

  const onWatchEventHandler = useCallback(({ origin, data: { operation } }) => {
    if (origin === window.location.origin) {
      switch (operation) {
        case IFRAME_MODAL_MESSAGE_EVENT_NAME.OPEN: {
          updateVisibility(false);
          break;
        }
        case IFRAME_MODAL_MESSAGE_EVENT_NAME.CLOSE: {
          updateVisibility(true);
          break;
        }
        default: {
          // do nothing
        }
      }
    }
  }, []);

  useEffect(() => {
    const matchingRoutes = checkMatchingRoutes(routes, hash);
    updateVisibility(matchingRoutes);
  }, [hash, pathname, routes]);

  useEffect(() => {
    window.addEventListener('message', onWatchEventHandler);
    return () => window.removeEventListener('message', onWatchEventHandler);
  }, [onWatchEventHandler]);

  return isVisible;
};

export default useVisibiityForLegacyUrl;
